import React from 'react';
import { NextSeo } from 'next-seo';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TlcStaticPage from '../../components/templates/TlcStaticPage/TlcStaticPage';
import { useTranslation } from '@/src/i18n';
import { getArticleBySlug } from '@/src/hooks/articles/fetchers';
import { tlcCardsActions } from '@/src/actions';
import { readingTime } from '@/src/utils';
import { wrapper } from '@/src/store';
import waitSagaMiddleware from '@/src/ssr/waitSagaMiddleware';

type Props = {
  articles: any;
};
const TLCStatic = ({ articles }) => {
  const { t } = useTranslation();
  return (
    <>
      <NextSeo
        title={t('seo-title_tlc_static')}
        description={t('seo-description_tlc_static')}
      />
      <TlcStaticPage articles={articles} />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps<Props>(
  store => async ({ locale }) => {
    store.dispatch(tlcCardsActions.getActions(false).getList());
    try {
      const article: ArticleDTO = await getArticleBySlug('teleconsultation');
      const relatedArticlesWithReadingTime = article?.relatedArticles.map(
        relatedArticle => ({
          ...relatedArticle,
          readingTime: readingTime(relatedArticle),
        }),
      );
      await waitSagaMiddleware(store);
      return {
        props: {
          articles: relatedArticlesWithReadingTime || [],
          ...(await serverSideTranslations(locale || 'fr', ['tlcStaticPage'])),
        },
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('error prefetching article', err);
      return { props: { articles: [] } };
    }
  },
);

export default TLCStatic;
